export const NOTIFICA_SUCCESSO = 'success'
export const NOTIFICA_ERRORE = 'error'
export const NOTIFICA_INFO = 'info'

export const TIPO_DATI_CENSIMENTI = 'censimenti'
export const TIPO_DATI_MANUTENZIONI = 'manutenzioni'

export const INTERVENTO_FITOSANITARIO_DANNI_DA_INSETTI = 1
export const INTERVENTO_FITOSANITARIO_MICOSI = 2
export const POTATURA_NON_DA_POTARE = 1
export const POTATURA_DA_POTARE = 2
export const POTATURA_DA_POTARE_PRECEDENTEMENTE_CAPITOZZATO = 3
//
export const INTERVENTO_ESEGUITO_POTATURA = 1
export const INTERVENTO_ESEGUITO_FITOSANITARIO_DANNI_DA_INSETTI = 3
export const INTERVENTO_ESEGUITO_FITOSANITARIO_MICOSI = 2

// export const COLOR_PIANTA_DA_POTARE_URGENTEMENTE = '#ff0000'
export const COLOR_PIANTA_DA_POTARE = '#f6f930'
export const COLOR_PIANTA_POTATA = '#fff'
export const COLOR_PIANTA_CON_DANNI_DA_INSETTO = '#ff0000'
export const COLOR_PIANTA_CON_DANNI_DA_INSETTO_FIXED = '#fff'
export const COLOR_PIANTA_CON_MICOSI = '#ff93f5'
export const COLOR_PIANTA_CON_MICOSI_FIXED = '#fff'

export const URGENZA_INTERVENTO_IMMEDIATO = 1
export const URGENZA_INTERVENTO_URGENTE = 2
export const URGENZA_INTERVENTO_ENTRO_TRE_ANNI = 3
export const URGENZA_INTERVENTO_OPZIONALE = 4

// comuni
export const COMUNE_CASALECCHIO = 'casalecchio'
export const COMUNE_COMACCHIO = 'comacchio'

// formatto per geojson opernlayer
// impostiamo il formatto
import GeoJSON from 'ol/format/GeoJSON'
export const OPEN_LAYER_GEOJSON_FORMAT = new GeoJSON({
    featureProjection: 'EPSG:3857',
    defaultDataProjection: 'EPSG:4326'
})
